// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-title[data-v-5e7d376c] {\n  font-size: 32px;\n  padding: 0;\n  line-height: normal;\n}\n.shadowCard[data-v-5e7d376c]{\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n  border: .5px solid transparent\n}\n.fontNormal[data-v-5e7d376c]{\n  font-weight: 400;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
